/** Admin sidebar items. `to` is the real route; `end` matches the index exactly. */
export const ADMIN_NAV = [
  { to: "/admin", end: true, label: "Dashboard", icon: "📊" },
  { to: "/admin/slides", label: "Homepage", icon: "🏠" },
  { to: "/admin/marquee", label: "Notice Ticker", icon: "📣" },
  { to: "/admin/sections", label: "Sections", icon: "🏛" },
  { to: "/admin/institutions", label: "Institutions", icon: "🎓" },
  { to: "/admin/departments", label: "Departments", icon: "🏛️" },
  { to: "/admin/notices", label: "Notices", icon: "📢" },
  // Results is hidden from the sidebar (school dropped the public Results tab);
  // the /admin/results editor still exists at its URL if ever needed again.
  { to: "/admin/gallery", label: "Photo Gallery", icon: "🖼" },
  { to: "/admin/activity", label: "Activity Page", icon: "🎭" },
  { to: "/admin/management", label: "Management", icon: "👥" },
  { to: "/admin/teachers", label: "Teachers", icon: "🧑‍🏫" },
  { to: "/admin/academics", label: "Academics", icon: "📚" },
  { to: "/admin/about", label: "About Page", icon: "ℹ️" },
  { to: "/admin/admissions", label: "Applications", icon: "📝" },
  { to: "/admin/admissions-info", label: "Admissions Page", icon: "🎓" },
  { to: "/admin/admission-rounds", label: "Admission Settings", icon: "🗓" },
  { to: "/admin/admission-resources", label: "Payment & Forms", icon: "💳" },
  { to: "/admin/messages", label: "Messages", icon: "✉️" },
  { to: "/admin/settings", label: "Settings", icon: "⚙️" },
];

/** Page title shown in the topbar for the current route (matches by path segment). */
export const titleForPath = (pathname) =>
  // `end` has to be honoured here too: without it the "/admin" entry's prefix
  // match swallows every subpage, and the topbar read "Dashboard" everywhere.
  ADMIN_NAV.find((n) =>
    n.end ? pathname === n.to : pathname === n.to || pathname.startsWith(`${n.to}/`)
  )?.label || "Dashboard";
